import { Pipe, PipeTransform } from '@angular/core';
import momentTz from 'moment-timezone';
import { IExpert } from '../../../../shared/models/expert.interface';

@Pipe({
  name: 'expertListValue',
  standalone: false,
})
export class ExpertListValuePipe implements PipeTransform {
  // Note: no 12 vs 24 clock handling found here
  transform(expert: IExpert, field: keyof IExpert, timezone: string): string {
    switch (field) {
      case 'firstName':
        return `${expert.firstName} ${expert.lastName}`.trim();

      case 'lastUpdated':
        return momentTz(expert.lastUpdated * 1000)
          .tz(timezone)
          .format('ddd MMM DD YYYY, LT');

      case 'callTime':
        return momentTz(expert.callTime)
          .tz(timezone)
          .format('ddd MMM DD YYYY, LT');

      default:
        return this.defaultTransform(expert[field]);
    }
  }

  private defaultTransform(value: IExpert[keyof IExpert]): string {
    if (Array.isArray(value)) {
      return value.flatMap((v) => v).join(', ');
    }

    return String(value);
  }
}
